export interface FrameRate {
  readonly id: FrameRateId;
  readonly label: string;
  readonly numerator: number;
  readonly denominator: number;
  readonly fps: number;
  readonly isDropFrame: boolean;
}

export type FrameRateId =
  | 'fps_2398'
  | 'fps_24'
  | 'fps_25'
  | 'fps_2997'
  | 'fps_30'
  | 'fps_50'
  | 'fps_5994'
  | 'fps_60';

function rate(
  id: FrameRateId,
  label: string,
  numerator: number,
  denominator: number,
  isDropFrame: boolean,
): FrameRate {
  return { id, label, numerator, denominator, fps: numerator / denominator, isDropFrame };
}

export const FRAME_RATES: readonly FrameRate[] = [
  rate('fps_2398', '23.98', 24000, 1001, false),
  rate('fps_24', '24', 24, 1, false),
  rate('fps_25', '25', 25, 1, false),
  rate('fps_2997', '29.97', 30000, 1001, true),
  rate('fps_30', '30', 30, 1, false),
  rate('fps_50', '50', 50, 1, false),
  rate('fps_5994', '59.94', 60000, 1001, true),
  rate('fps_60', '60', 60, 1, false),
];

const BY_ID: Map<FrameRateId, FrameRate> = new Map(FRAME_RATES.map((r) => [r.id, r]));

export function getFrameRate(id: FrameRateId): FrameRate {
  const found = BY_ID.get(id);
  if (!found) throw new Error(`Unknown frame rate id: ${id}`);
  return found;
}

export function isFrameRateId(value: unknown): value is FrameRateId {
  return typeof value === 'string' && BY_ID.has(value as FrameRateId);
}

export const DEFAULT_FRAME_RATE_ID: FrameRateId = 'fps_30';
